// trackingCookies.ts
export type FbCookies = { fbp: string | null; fbc: string | null };

function readCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';').shift() || null;
  return null;
}

export function getFacebookCookies(): FbCookies {
  const url = new URL(window.location.href);
  const fbclid = url.searchParams.get('fbclid');
  const fbp = readCookie('_fbp');
  const fbcCookie = readCookie('_fbc');
  const fbc = fbcCookie || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : null);
  return { fbp, fbc };
}
